(function () {
    angular
        .module("app")
        .factory('googleMap', googleMap);

    googleMap.$inject = [];

    function googleMap() {
        var _id = "map";
        var _map;
        var _city;
        var _markersArray = [];
        var bounds = new google.maps.LatLngBounds();

        var service = {
            addMarker: addMarker,
            createPoint: createPoint,
            getId: getId,
            setId: setId,
            showMap: showMap,
        };

        return service;

        function getId() {
            return _id;
        }

        function setId(newId) {
            _id = newId;
        }

        function createPoint(marker){
            _markersArray.push(marker)
        }

        function addMarker(item) {

            var marker = new google.maps.Marker({
                position: {
                    lat: item.lat,
                    lng: item.lng
                },
                map: _map,
                icon: "media/marker.png",
            });

            bounds.extend(marker.position);
            _map.fitBounds(bounds);

            marker.addListener('click', function () {
                infowindow.open(_map, marker);
            });
        }

        function showMap() {
            var mapOption = {
                scrollwheel: false, //desativar scroll
                mapTypeControl: false, //desativa opcao de escolha de mapa
                panControl: false, //desativa movimentacao no mapa
                disableDefaultUI: false
                //zoomControl: false, //desativa zomm no mapa
            };

            _map = new google.maps.Map(document.getElementById(getId()), mapOption);
            //Todas as cidades
            _markersArray.forEach(function (item) {
                addMarker(item, _map);
            });
        }
        
    }
})();